import React from "react";
import SEO from "../components/SEO";
import LegalShell from "../components/LegalShell";

export default function CGU() {
  return (
    <LegalShell eyebrow="Légal" title="Conditions Générales d'Utilisation" lastUpdate="29 avril 2026" testid="page-cgu">
      <SEO
        title="CGU — Conditions Générales d'Utilisation MetaConnect"
        description="Conditions Générales d'Utilisation du site metaconnect.fr et des services associés."
        canonical="/cgu"
      />

      <h2>Article 1 — Objet</h2>
      <p>
        Les présentes Conditions Générales d'Utilisation (ci-après «&nbsp;CGU&nbsp;») ont pour
        objet de définir les modalités et conditions dans lesquelles l'éditeur, la société
        <strong>METACONNECT.FR</strong>, SAS au capital de 1 000 €, immatriculée au RCS d'Orléans
        sous le numéro 931 999 833, dont le siège social est situé 68 route de la Ferté-Saint-Aubin,
        45150 Jargeau (ci-après «&nbsp;MetaConnect&nbsp;»), met à disposition de l'utilisateur
        (ci-après l'«&nbsp;Utilisateur&nbsp;») le site metaconnect.fr (ci-après le «&nbsp;Site&nbsp;»)
        et les services qui y sont associés (formulaire de demande de démonstration, blog,
        contenus informationnels).
      </p>
      <p>
        L'utilisation du Site implique l'acceptation pleine et entière des présentes CGU. Si
        l'Utilisateur n'accepte pas tout ou partie des CGU, il lui est demandé de renoncer à
        l'usage du Site.
      </p>

      <h2>Article 2 — Accès au Site</h2>
      <p>
        Le Site est accessible gratuitement à toute personne disposant d'un accès Internet. Tous
        les coûts liés à l'accès au Site (matériel informatique, logiciels, connexion Internet,
        etc.) sont à la charge exclusive de l'Utilisateur.
      </p>
      <p>
        MetaConnect met en œuvre des moyens raisonnables pour assurer la disponibilité du Site
        24h/24 et 7j/7. L'éditeur se réserve toutefois le droit, sans préavis ni indemnité, de
        suspendre temporairement ou définitivement le Site, notamment pour des opérations de
        maintenance, mises à jour, ou en cas de force majeure.
      </p>

      <h2>Article 3 — Services proposés</h2>
      <p>Le Site propose notamment&nbsp;:</p>
      <ul>
        <li>la présentation des solutions et modules MetaConnect&nbsp;;</li>
        <li>un formulaire de demande de démonstration permettant à un prospect de planifier un échange&nbsp;;</li>
        <li>un blog éditorial dédié à l'e-santé, à l'interopérabilité et à la conformité réglementaire&nbsp;;</li>
        <li>des informations sur la conformité aux référentiels nationaux du numérique en santé.</li>
      </ul>
      <p>
        Aucune transaction commerciale n'est réalisée directement sur le Site. La souscription
        éventuelle aux services MetaConnect fait l'objet d'un contrat distinct entre l'éditeur
        et le client professionnel.
      </p>

      <h2>Article 4 — Engagements de l'Utilisateur</h2>
      <p>L'Utilisateur s'engage à&nbsp;:</p>
      <ul>
        <li>utiliser le Site conformément aux lois et règlements en vigueur&nbsp;;</li>
        <li>fournir des informations exactes lors de toute demande (formulaire de démo, contact)&nbsp;;</li>
        <li>ne pas perturber le bon fonctionnement du Site (tentatives d'intrusion, scraping massif, attaques par déni de service, etc.)&nbsp;;</li>
        <li>ne pas porter atteinte aux droits de propriété intellectuelle de l'éditeur ou de tiers.</li>
      </ul>

      <h2>Article 5 — Propriété intellectuelle</h2>
      <p>
        L'ensemble du Site (architecture, code, design, textes, logos, illustrations, marques,
        bases de données) est la propriété exclusive de MetaConnect ou de ses partenaires, et
        est protégé par les lois françaises et internationales relatives à la propriété
        intellectuelle. Toute reproduction, représentation, adaptation ou diffusion, totale ou
        partielle, sans autorisation écrite préalable, est strictement interdite et constituerait
        une contrefaçon sanctionnée par les articles L.335-2 et suivants du Code de la propriété
        intellectuelle.
      </p>

      <h2>Article 6 — Données personnelles</h2>
      <p>
        Les données personnelles éventuellement collectées via le Site (nom, email,
        organisation, message) sont traitées conformément à notre&nbsp;
        <a href="/donnees">Charte de protection des données</a> et au Règlement (UE) 2016/679
        (RGPD) ainsi qu'à la loi n° 78-17 du 6 janvier 1978 modifiée.
      </p>

      <h2>Article 7 — Cookies</h2>
      <p>
        Le Site utilise un nombre limité de cookies strictement nécessaires à son fonctionnement
        (authentification de l'espace administrateur). Aucun cookie publicitaire ni cookie de
        suivi tiers n'est déposé sans le consentement préalable de l'Utilisateur. Les détails
        sont précisés dans la <a href="/donnees">Charte de protection des données</a>.
      </p>

      <h2>Article 8 — Limitation de responsabilité</h2>
      <p>
        Les informations diffusées sur le Site ont une vocation informative et ne sauraient se
        substituer à un avis professionnel ou juridique. MetaConnect ne saurait être tenu pour
        responsable des dommages directs ou indirects résultant&nbsp;:
      </p>
      <ul>
        <li>d'une utilisation non conforme du Site&nbsp;;</li>
        <li>d'une interruption ou indisponibilité temporaire du Site&nbsp;;</li>
        <li>d'une perte de données ou d'une faille de sécurité résultant d'un cas de force majeure ou du fait d'un tiers&nbsp;;</li>
        <li>du contenu de sites tiers accessibles via des liens hypertextes.</li>
      </ul>

      <h2>Article 9 — Modification des CGU</h2>
      <p>
        MetaConnect se réserve le droit de modifier les présentes CGU à tout moment. La version
        en vigueur est celle accessible sur le Site à la date de connexion de l'Utilisateur. Il
        est recommandé à l'Utilisateur de consulter régulièrement cette page.
      </p>

      <h2>Article 10 — Droit applicable &amp; juridiction</h2>
      <p>
        Les présentes CGU sont régies par le droit français. Tout litige relatif à leur
        interprétation ou à leur exécution relève de la compétence exclusive des tribunaux
        d'<strong>Orléans</strong>, après tentative de résolution amiable préalable.
      </p>

      <h2>Article 11 — Contact</h2>
      <p>
        Pour toute question relative aux présentes CGU, vous pouvez nous écrire à&nbsp;:
        <a href="mailto:contact@metaconnect.fr"> contact@metaconnect.fr</a>.
      </p>
    </LegalShell>
  );
}
